module.exports = __webpack_public_path__ + "img/comprarammespassado.ae3fca63.png";